import type Matter from "matter-js";
import type { BubbleManager } from "../entities/BubbleManager";

export class MergeSystem {
  private merging = new Set<number>();

  constructor(private readonly bubbles: BubbleManager) {}

  beginFrame(): void {
    this.merging.clear();
  }

  handle(bodyA: Matter.Body, bodyB: Matter.Body): void {
    if (bodyA.label !== "bubble" || bodyB.label !== "bubble") return;

    const a = this.bubbles.get(bodyA);
    const b = this.bubbles.get(bodyB);
    if (!a || !b) return;
    if (a.state !== "Alive" || b.state !== "Alive") return;
    if (a.bornAbove !== b.bornAbove) return;
    if (this.merging.has(a.id) || this.merging.has(b.id)) return;

    const keep = a.radius >= b.radius ? a : b;
    const eaten = keep === a ? b : a;
    if (!this.bubbles.canAbsorbMore(keep)) return;

    this.merging.add(a.id);
    this.merging.add(b.id);
    this.bubbles.mergeInto(keep, eaten);
  }
}
